import type { FC } from "react";

import { useTranslation } from "src/translations";
import type { AntCustomFormField } from "../../types/types";

interface UploadInputProps extends AntCustomFormField<string> {
    name: string;
    label: string;
    readOnly: boolean;
}

export const UploadFile: FC<UploadInputProps> = ({ readOnly, label, name, onChange }) => {
    const { t } = useTranslation();

    const onSelectedFile = (ev: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            const { files } = ev.target;
            const file = files?.item(0);
            if (file) {
                file.text().then((content) => onChange(content));
            }
        }
    };

    return (
        <>
            <label>{t(label)}</label>
            <input type="file" name={name} disabled={readOnly} onChange={onSelectedFile} />
        </>
    );
};
